export default __webpack_public_path__ + "static/media/t1.d6ad4ac3.webp";